
export const enCommon = {
  // Navigation
  nav_home: 'Home',
  nav_services: 'Services',
  nav_cases: 'Cases',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_apply: 'For Creators',
  nav_consult: 'Get Started',
  nav_articles: 'Latest News',
  footer_articles: 'Latest News',

  // Company Info
  company_name: 'Koluno',
  company_desc: 'Focused on global influencer integrated marketing, connecting brands with creators for measurable business growth',
  
  // Hero Section
  hero_title: 'Global Influencer',
  hero_title_highlight: 'Marketing Solutions',
  hero_subtitle: 'Global Influencer Marketing Solutions',
  hero_description: 'Connecting brands with global creators, combining influencer marketing + advertising amplification + data analysis for measurable growth',
  hero_brand_btn: 'I\'m a Brand',
  hero_creator_btn: 'I\'m a Creator',
  
  // Our Value
  value_title: 'Our Value Proposition',
  value_subtitle: 'Professional integrated marketing services that create measurable business value for brands',
  
  // Value Features
  value_global_network: 'Global Creator Network',
  value_global_network_desc: 'Covering 50+ countries and regions, 200+ quality creator resources, precise brand matching, rapid project launch',
  
  value_integrated_marketing: 'Integrated Marketing Solutions',
  value_integrated_marketing_desc: 'Creator marketing + advertising + data analysis, one-stop service from strategy to execution with full professional support',
  
  value_transparent_data: 'Transparent Data & Reporting',
  value_transparent_data_desc: 'Real-time data monitoring, detailed performance reports, clear ROI visibility, continuous optimization for maximum marketing effectiveness',
  
  value_category_expertise: 'Category Expertise & Playbooks',
  value_category_expertise_desc: 'Deep industry marketing experience, mature methodology systems, customized strategies for different categories to improve conversion efficiency',
  
  value_fast_execution: 'Fast Execution & Flexible Support',
  value_fast_execution_desc: '24-hour response to requirements, flexible cooperation models, professional team full follow-up to ensure timely high-quality delivery',

  // Services
  services_title: 'Services Preview',
  services_subtitle: 'Services Preview',
  services_description: 'Three core services to meet marketing needs at different stages',
  
  service_influencer: 'Influencer Collaborations',
  service_influencer_en: 'Influencer Collaborations',
  service_influencer_desc: 'Match creators by scenario for rapid scaling, including selection, communication, content review, and launch tracking',
  service_influencer_feature1: 'Precise Creator Matching',
  service_influencer_feature2: 'Content Quality Control',
  service_influencer_feature3: 'Full Project Tracking',
  service_influencer_feature4: 'Data Performance Monitoring',
  
  service_amplification: 'Ad Amplification',
  service_amplification_en: 'Ad Amplification',
  service_amplification_desc: 'Licensed creator content advertising with targeting strategies and budget allocation for higher conversion',
  service_amplification_feature1: 'Content Licensed Advertising',
  service_amplification_feature2: 'Precise Targeting Strategy',
  service_amplification_feature3: 'Budget Optimization',
  service_amplification_feature4: 'Conversion Rate Improvement',
  
  service_integrated: 'One-Stop Integrated Plan',
  service_integrated_en: 'One-Stop Integrated Plan',
  service_integrated_desc: 'Full-process delivery from strategy to execution to data review, with clear KPIs and milestones',
  service_integrated_feature1: 'Full-Process Service',
  service_integrated_feature2: 'Strategy Development & Execution',
  service_integrated_feature3: 'Data Review & Optimization',
  service_integrated_feature4: 'KPI Goal Management',
  
  btn_learn_details: 'Learn More',
  btn_view_full_services: 'View Complete Service Solutions',
  
  // Case Studies
  cases_title: 'Case Studies Preview',
  cases_subtitle: 'Case Studies Preview',
  cases_description: 'Real case testimonials, data-driven marketing results',
  
  case_baby_category: 'Baby & Maternity',
  case_baby_platform: 'Xiaohongshu',
  case_baby_title: 'Premium Baby Products Global Promotion',
  case_baby_desc: 'Achieved explosive growth for the brand on Xiaohongshu through precise creator matching and content strategy',
  
  case_beauty_category: 'Beauty Brand',
  case_beauty_platform: 'Douyin/TikTok',
  case_beauty_title: 'International Beauty Brand Cross-border Marketing',
  case_beauty_desc: 'Achieved breakthrough growth on both Douyin and TikTok platforms through creator marketing and advertising',
  
  case_smart_category: 'Lifestyle Products',
  case_smart_platform: 'Cross-border Advertising',
  case_smart_title: 'Smart Home Products Global Market Expansion',
  case_smart_desc: 'Successfully launched smart home products in 15 countries through multi-platform integrated marketing',
  
  metric_exposure: 'Exposure',
  metric_engagement: 'Engagement Rate',
  metric_sales: 'Sales Growth',
  metric_conversion: 'Conversion Rate',
  metric_live_uv: 'Live UV',
  metric_roas: 'ROAS',
  metric_followers: 'Follower Growth',
  metric_countries: 'Countries Covered',
  
  btn_view_more_cases: 'View More Success Cases',
  
  // Process
  process_title: 'How It Works',
  process_subtitle: 'How It Works',
  process_description: 'Standardized process, professional service, ensuring every project achieves expected results',
  
  process_step1: 'Requirements Analysis',
  process_step1_en: 'Requirements Analysis',
  process_step1_desc: 'Deep understanding of brand needs, clarify marketing goals, develop initial strategic direction',
  process_step1_detail1: 'Brand Research & Analysis',
  process_step1_detail2: 'Target Audience Positioning',
  process_step1_detail3: 'Competitive Strategy Research',
  process_step1_detail4: 'Budget Planning Recommendations',
  
  process_step2: 'Strategy & Creator Selection',
  process_step2_en: 'Strategy & Creator Selection',
  process_step2_desc: 'Develop detailed marketing strategy, precisely match quality creator resources',
  process_step2_detail1: 'Marketing Strategy Development',
  process_step2_detail2: 'Precise Creator Matching',
  process_step2_detail3: 'Content Creative Planning',
  process_step2_detail4: 'Timeline Scheduling',
  
  process_step3: 'Execution & Amplification',
  process_step3_en: 'Execution & Amplification',
  process_step3_desc: 'Content production and launch, advertising amplification, real-time monitoring and optimization',
  process_step3_detail1: 'Content Production Supervision',
  process_step3_detail2: 'Multi-platform Synchronized Publishing',
  process_step3_detail3: 'Advertising Optimization',
  process_step3_detail4: 'Real-time Data Monitoring',
  
  process_step4: 'Data Analysis & Review',
  process_step4_en: 'Data Analysis & Review',
  process_step4_desc: 'Comprehensive data analysis, performance review and summary, continuous strategy optimization',
  process_step4_detail1: 'Performance Data Analysis',
  process_step4_detail2: 'ROI Calculation Report',
  process_step4_detail3: 'Strategy Optimization Recommendations',
  process_step4_detail4: 'Next Phase Planning',
  
  process_team_title: 'Professional Team, Full Service',
  process_team_desc: 'Our professional team will provide support at every stage to ensure smooth project progress and expected results',
  process_response_time: '24-hour Response',
  process_quality_guarantee: 'Quality Guarantee',
  process_dedicated_service: 'Dedicated Support',
  process_continuous_optimization: 'Continuous Optimization',
  
  // Contact
  contact_title: 'Contact Us',
  contact_description: 'Multiple contact methods, professional team providing comprehensive support',
  contact_email_desc: 'Reply within 24 hours on business days',
  contact_telegram_desc: 'Instant communication, quick response',
  contact_wechat_desc: 'Professional customer service team online',
  
  contact_promise_title: 'Quick Response Promise',
  contact_email_time: '24 Hours',
  contact_email_time_desc: 'Email Response Time',
  contact_instant_time: '2 Hours',
  contact_instant_time_desc: 'Instant Messaging Response',
  contact_matching_time: '48 Hours',
  contact_matching_time_desc: 'Cooperation Matching Time',
  
  // CTA Section
  cta_title: 'Ready to Get Started?',
  cta_subtitle: 'Ready to get started?',
  cta_description: 'Contact us now to get customized marketing solutions and start your brand\'s global growth journey',
  
  cta_phone_title: 'Phone Consultation',
  cta_phone_desc: 'One-on-one professional advisor service',
  cta_email_title: 'Email Contact',
  cta_email_desc: 'Detailed requirement communication',
  cta_wechat_title: 'WeChat Consultation',
  cta_wechat_desc: 'Instant communication',

  // About Page
  about_title: 'About Us',
  about_subtitle: 'Focused on global creator integrated marketing, providing one-stop marketing solutions for brands',
  about_global_vision: 'Global Vision',
  about_global_vision_desc: 'Covering 50+ countries and regions worldwide',
  about_professional_team: 'Professional Team',
  about_professional_team_desc: 'Experienced marketing expert team',
  about_excellent_results: 'Excellent Results',
  about_excellent_results_desc: '200+ successful cooperation cases',
  
  // Vision & Mission
  vision_mission_title: 'Vision & Mission',
  vision_mission_subtitle: 'Vision & Mission',
  our_vision: 'Our Vision',
  our_vision_desc: 'To become the world\'s leading creator integrated marketing platform, connecting quality creators and brands worldwide, driving innovative development of global business cooperation.',
  our_mission: 'Our Mission',
  our_mission_desc: 'We are committed to providing one-stop integrated marketing solutions for brands through "creator marketing + advertising + data analysis", helping clients improve sales and influence, and quickly enter global markets.',
  
  // Positioning
  positioning_title: 'Our Positioning',
  positioning_subtitle: 'Our Positioning',
  positioning_desc: 'We are not just a matching platform, but a long-term marketing partner for clients, focusing on result-oriented and executable promotion solutions',
  long_term_partner: 'Long-term Marketing Partner',
  long_term_partner_desc: 'We are not just a matching platform, but a long-term marketing partner for clients, growing together with you',
  result_oriented: 'Result-Oriented',
  result_oriented_desc: 'Focus on measurable marketing results, every investment must see clear returns',
  executable_solutions: 'Executable Solutions',
  executable_solutions_desc: 'Provide practical promotion solutions, from strategy to execution, with full professional guidance',
  professional_service: 'Professional Service',
  professional_service_desc: 'Experienced marketing expert team, providing one-on-one professional consultation and full-service support',
  why_choose_us_partner: 'Why Choose Us as Your Marketing Partner?',
  why_choose_us_partner_desc: 'In a competitive market environment, brands need not just one-time marketing services, but long-term partners who can continuously create value. We deeply understand each client\'s business needs, develop personalized marketing strategies, and continuously optimize results through data-driven methods to ensure every cooperation brings real business value to clients.',
  
  // Milestones
  milestones_title: 'Milestones & Numbers',
  milestones_subtitle: 'Milestones & Numbers',
  milestones_desc: 'Let the data speak, prove our professional strength with results',
  creator_partners: 'Creator Partners',
  creator_partners_en: 'Creator Partners',
  creator_partners_desc: 'Established deep cooperation with 200+ quality creators worldwide',
  countries_regions: 'Countries & Regions',
  countries_regions_en: 'Countries & Regions',
  countries_regions_desc: 'Business covers 50+ countries and regional markets worldwide',
  response_time: 'Hours Project Response',
  response_time_en: 'Hours Response Time',
  response_time_desc: 'Committed to responding to client project needs within 24 hours',
  client_satisfaction: 'Client Satisfaction',
  client_satisfaction_en: 'Client Satisfaction',
  client_satisfaction_desc: 'Over 98% of clients are satisfied with our services',
  development_history: 'Development History',
  year_2023: 'Global Expansion',
  year_2023_desc: 'Business expanded to 50+ countries, established global creator network',
  year_2022: 'Technology Upgrade',
  year_2022_desc: 'Launched data analysis platform, achieved marketing effect visualization',
  year_2021: 'Service Innovation',
  year_2021_desc: 'Launched integrated marketing solutions, one-stop service model',
  year_2020: 'Company Founded',
  year_2020_desc: 'Koluno officially founded, focusing on creator marketing services',
  
  // CTA
  ready_to_start: 'Ready to Get Started?',
  ready_to_start_en: 'Ready to get started?',
  ready_to_start_desc: 'Contact us now to get customized marketing solutions and start your brand\'s global growth journey',
  contact_us: 'Contact Us',
  email_consultation: 'Email Consultation',
  wechat_consultation: 'WeChat Consultation',

  // Creator Application Page
  apply_title: 'Join Our Creator Alliance',
  apply_subtitle: 'Collaborate with top global brands, earn generous income, maximize your creative value',
  apply_income: 'Monthly income up to $5000+',
  apply_brands: 'Collaborate with 500+ famous brands',
  apply_support: 'Professional team full support',
  apply_now: 'Apply Now',
  
  // Benefits
  benefits_title: 'Why Choose Us?',
  benefits_desc: 'We provide comprehensive support and resources for creators to help you achieve greater success in content creation',
  rich_income: 'Rich Income',
  rich_income_desc: 'Based on followers and engagement rate, monthly income can reach $1000-$10000+, with additional rewards for outstanding performers',
  global_brands: 'Global Brand Resources',
  global_brands_desc: 'Direct cooperation with 500+ international famous brands like Nike, Apple, Samsung, get exclusive products and experiences',
  professional_support: 'Professional Team Support',
  professional_support_desc: 'Equipped with dedicated agents, content planners and data analysts to comprehensively improve creative effects',
  growth_opportunities: 'Growth Opportunities',
  growth_opportunities_desc: 'Regular training courses, industry summit invitations, exchange and learning with top creators, rapidly improve influence',
  contract_protection: 'Contract Protection',
  contract_protection_desc: 'Transparent cooperation terms, timely fee settlement, comprehensive legal protection, let you create with peace of mind',
  data_insights: 'Data Insights',
  data_insights_desc: 'Professional data analysis reports to help you understand audience preferences, optimize content strategies, improve monetization efficiency',
  
  // Requirements
  requirements_title: 'Application Requirements',
  requirements_desc: 'We are looking for talented and influential creators to join our creator network',
  basic_requirements: 'Basic Requirements',
  follower_requirements: 'Follower Requirements',
  content_quality: 'Content Quality',
  cooperation_attitude: 'Cooperation Attitude',
  tip_title: 'Friendly Reminder',
  tip_desc: 'Even if you don\'t meet all requirements currently, we welcome your application! We evaluate creators comprehensively based on potential and uniqueness, providing growth support and training opportunities for promising creators.',

  // Apply form
  apply_form_title: 'Join Us',
  apply_form_desc: 'Fill in detailed information to help us understand you better',
  or_contact_directly: 'Or Contact Us Directly',
  basic_info: 'Basic Information',
  platform_info: 'Platform Information',
  cooperation_preference: 'Cooperation Preference',
  contact_info: 'Contact Information',
  message_optional: 'Message (Optional)',
  privacy_agreement: 'I have read and agree to the',
  privacy_policy: 'Privacy Policy',
  terms_of_service: 'Terms of Service',
  privacy_agreement_desc: ', and agree to receive relevant cooperation information',
  submitting: 'Submitting...',
  submit_application: 'Submit Application',
  submit_success: 'Application submitted successfully! We will contact you within 24 hours.',
  submit_error: 'Submission failed, please try again later or contact us directly.',

  // Common Buttons
  btn_contact_now: 'Contact Now',
  btn_learn_more: 'Learn More',
  btn_get_started: 'Get Started',
  
  // Contact Info
  // Updated Contact Section
  contact_email: 'Email',
  contact_wechat: 'WeChat',
  contact_telegram: 'Telegram',
  contact_wechat_qr: 'WeChat QR Code',
  contact_choose_method: 'Choose your preferred contact method',
  
  // Footer
  footer_quick_links: 'Quick Links',
  footer_services: 'Services',
  footer_contact_info: 'Contact Info',
  footer_all_rights_reserved: 'All rights reserved',
  footer_privacy_policy: 'Privacy Policy',
  footer_terms_of_service: 'Terms of Service',
  
  // Footer Services
  footer_service_influencer: 'Influencer Marketing',
  footer_service_advertising: 'Advertising',
  footer_service_analytics: 'Data Analytics',
  footer_service_strategy: 'Brand Strategy',

  // Page Titles
  page_title_home: 'Koluno - Global Influencer Marketing Solutions',
  page_title_about: 'Koluno - About Us',
  page_title_apply: 'Koluno - Join Our Creator Alliance',
  page_title_privacy: 'Koluno - Privacy Policy',
  page_title_terms: 'Koluno - Terms of Service',
};

export default enCommon;
